import { Alert, AlertIcon, AlertText } from "@/components/ui/alert";
import { HStack } from "@/components/ui/hstack";
import { VStack } from "@/components/ui/vstack";
import { useUserControllerMe } from "@/generated/api/api";
import { ActionItem } from "@/screens/common/action.list.items";
import { Info } from "lucide-react-native";
import { Link as ExpoLink } from "expo-router";
import { OrganizationDTO } from "@/generated/api/models";
import { useMemo } from "react";

type AlertType = "VERIFY_IBAN" | "FILL_BASIC_INFO" | "EXPLORE_QR";

const GUIDE_DURATION = 1000 * 60 * 60 * 24 * 7; // 7 days

export function RestaurantActionList({ org }: { org: OrganizationDTO }) {
  const { data: me } = useUserControllerMe();

  const actions = useMemo(() => {
    const r: AlertType[] = [];
    if (me?.id === org.ownerId && me.beneficiary?.status !== "APPROVED") {
      r.push("VERIFY_IBAN");
    }

    const createdAt = new Date(org.createdAt as any);

    if (Date.now() - createdAt.getTime() <= GUIDE_DURATION) {
      r.push("EXPLORE_QR");
    }

    if (!org.avatarImage && !org.coverImage) {
      r.push("FILL_BASIC_INFO");
    }

    return r;
  }, [org, me]);

  if (!actions.length) {
    return <></>;
  }

  return (
    <Alert action="info" variant="solid" className="items-start mt-4">
      <VStack className="gap-2 w-full">
        <HStack className="gap-2 justify-center">
          <AlertIcon as={Info} />
          <AlertText>Next steps</AlertText>
        </HStack>
        {actions.map((a) => {
          switch (a) {
            case "VERIFY_IBAN":
              return (
                <ExpoLink key={a} href={"/(tabs)/profile"} replace>
                  <ActionItem
                    label="Add and verify your IBAN"
                    sublabel="Not all tipping methods are currently available. Please verify your IBAN to unlock them."
                  />
                </ExpoLink>
              );
            case "FILL_BASIC_INFO":
              return (
                <ActionItem
                  key={a}
                  label="Upload avatar and cover"
                  sublabel="Avatar and cover image helps to build trust and attract more tips."
                />
              );
            case "EXPLORE_QR":
              return (
                <ExpoLink
                  key={a}
                  href={{
                    pathname: "/(tabs)/orgs/[orgId]/qrcodes",
                    params: {
                      orgId: org.id,
                    },
                  }}
                  push
                >
                  <ActionItem
                    label="Explore QR code for business"
                    sublabel="Go to the Settings -> QR codes to view, print, and share your tip link."
                  />
                </ExpoLink>
              );
          }
        })}
      </VStack>
    </Alert>
  );
}
